function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import makeCancellable from 'make-cancellable-promise';
import invariant from 'tiny-invariant';
import warning from 'warning';
import StructTreeItem from './StructTreeItem.js';
import usePageContext from './shared/hooks/usePageContext.js';
import useResolver from './shared/hooks/useResolver.js';
import { cancelRunningTask } from './shared/utils.js';
export default function StructTree() {
  var pageContext = usePageContext();
  invariant(pageContext, 'Unable to find Page context.');
  var onGetStructTreeErrorProps = pageContext.onGetStructTreeError,
    onGetStructTreeSuccessProps = pageContext.onGetStructTreeSuccess;
  var _useResolver = useResolver(),
    _useResolver2 = _slicedToArray(_useResolver, 2),
    structTreeState = _useResolver2[0],
    structTreeDispatch = _useResolver2[1];
  var structTree = structTreeState.value,
    structTreeError = structTreeState.error;
  var customTextRenderer = pageContext.customTextRenderer,
    page = pageContext.page;
  function onLoadSuccess() {
    if (!structTree) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    if (onGetStructTreeSuccessProps) {
      onGetStructTreeSuccessProps(structTree);
    }
  }
  function onLoadError() {
    if (!structTreeError) {
      // Impossible, but TypeScript doesn't know that
      return;
    }
    warning(false, structTreeError.toString());
    if (onGetStructTreeErrorProps) {
      onGetStructTreeErrorProps(structTreeError);
    }
  }
  // biome-ignore lint/correctness/useExhaustiveDependencies: useEffect intentionally triggered on page change
  useEffect(function resetStructTree() {
    structTreeDispatch({
      type: 'RESET'
    });
  }, [structTreeDispatch, page]);
  useEffect(function loadStructTree() {
    if (customTextRenderer) {
      // TODO: Document why this is necessary
      return;
    }
    if (!page) {
      return;
    }
    var cancellable = makeCancellable(page.getStructTree());
    var runningTask = cancellable;
    cancellable.promise.then(function (nextStructTree) {
      structTreeDispatch({
        type: 'RESOLVE',
        value: nextStructTree
      });
    }).catch(function (error) {
      structTreeDispatch({
        type: 'REJECT',
        error: error
      });
    });
    return function () {
      return cancelRunningTask(runningTask);
    };
  }, [customTextRenderer, page, structTreeDispatch]);
  // biome-ignore lint/correctness/useExhaustiveDependencies: Ommitted callbacks so they are not called every time they change
  useEffect(function () {
    if (structTree === undefined) {
      return;
    }
    if (structTree === false) {
      onLoadError();
      return;
    }
    onLoadSuccess();
  }, [structTree]);
  if (!structTree) {
    return null;
  }
  return _jsx(StructTreeItem, {
    className: "react-pdf__Page__structTree structTree",
    node: structTree
  });
}